export default __webpack_public_path__ + "96bfc76620aef5ee6e3d3cedca8a3612.png";